// extracted by mini-css-extract-plugin
export var alertIcon = "_tf-0";